import { render, staticRenderFns } from "./ResolutionSelector.vue?vue&type=template&id=7d2dce5a&"
import script from "./ResolutionSelector.vue?vue&type=script&lang=js&"
export * from "./ResolutionSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports